import React, { useEffect, useState } from 'react'
import $ from 'jquery'

export default function Loglist() { 
    const [companyname, setCompanyname] = useState('');
    const [listLoginArray, setListLoginArray] = useState([]);
    const [selectedComLogo, setSelectedComLogo] = useState('');

    useEffect(() => {
        let comname = localStorage.getItem('mem_company_name');
        setCompanyname(comname);
        var comlogo = localStorage.getItem('companylogo');
        setSelectedComLogo(comlogo);
        let com_id = localStorage.getItem('mem_company_id');
        var obj = {
            com_id: com_id
        }
         $.ajax({
      type: 'POST',
      url: 'getLoginRecord.php',
      data: obj,
      cache: false,
      success: function (result) {
        var res = result;
        console.log(res);
        if (res !== 'fail' && res !== '') {
          try {
            var loginarr = res;
            // ensure it's an array
            if (Array.isArray(loginarr)) {
              var len = loginarr.length;
              if (len < 1) {
                showAlert('Cannot find any record.');
                setListLoginArray([]);
              } else {
                setListLoginArray(loginarr);
              }
            } else {
              setListLoginArray([]);
            }

          } catch (e) {
            console.error("Invalid JSON from backend:", e);
            setListLoginArray([]);
          }
        } else {
          showAlert('Cannot find any member.');
          setListLoginArray([]);
        }
      },
      error: function (xhr, status, error) {
        console.error("AJAX Error:", status, error, xhr.responseText);
      }
    });
    },[]);

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }
    return (
        <div>
            <div className='editbtn_holder'>
                <div className='membersinfoimg fullwidth'>
                    <div className='memberimgholder'>
                        <img id="memimg" src={selectedComLogo} />
                    </div>
                    <h2 id="companyname">{companyname}</h2>
                </div>
            </div>
            <div className='vl_alltab'>
                <button className='tabs'>Login List of {companyname} </button>
            </div>
            <section className='vl_dsh_bodypart_section pos_rel'>
                <div className='vl_listing_area'>
                    <div className='vl_listing_row'>
                        <div className='vl_listing_cell width20'>
                            <h4 className='prj_name'>User Name</h4>
                        </div>
                        <div className='vl_listing_cell width20'>
                            <p>Login date</p>
                        </div>

                        <div className='vl_listing_cell width20'>
                            <p>Login Time</p>
                        </div>
                        <div className='vl_listing_cell width20'>
                            <p>Email</p>
                        </div>
                        <div className='vl_listing_cell width20'>
                            <p>Role</p>
                        </div>
                    </div>
                    {Array.isArray(listLoginArray) && listLoginArray.map((item, index) => (
                                <div className="vl_listing_row" key={item.primary_key || index}>

                                    <div className="vl_listing_cell width20">
                                        <h4 className="prj_name">
                                            {item.username}
                                        </h4>
                                    </div>

                                    <div className="vl_listing_cell width20">
                                        <h4 className="prj_name">
                                            {item.login_date}
                                        </h4>

                                    </div>

                                    <div className="vl_listing_cell width20">
                                        <p>{item.login_time}</p>
                                    </div>

                                    <div className="vl_listing_cell width20">
                                        <p>{item.mem_email}</p>
                                    </div>

                                    <div className="vl_listing_cell width20">
                                        <p className='captext'>{item.mem_role}</p>
                                    </div>

                                </div>
                            ))}

                </div>
            </section>
        </div>
    )
}
